import { useState } from "react";
import "./Testimonials.css";

const reviews = [
  { quote: "From the moment we arrived, we felt at home.", text: "The welcome was warm, the room was spotless, and every detail was thoughtfully prepared. It was peaceful, comfortable, and beautifully managed from start to finish.", name: "Arta · Austria", source: "Vila Eva · Booking.com", stars: 5 },
  { quote: "Modern, Quiet & Comfortable", text: "A wonderful modern stay with very comfortable beds and a spacious bathroom. The location behind the pine forest makes it incredibly quiet and relaxing. Warm, attentive hosting throughout our stay.", name: "Kathrin · Germany", source: "Vila Eva · Booking.com", stars: 5 },
  { quote: "Perfect for Families", text: "Our kids loved the pool and the calm atmosphere just steps from the beach. The room was spotless, and we were even welcomed to use the pool before check-in. A peaceful place to truly enjoy vacation time together.", name: "Gerta & Family · Italy", source: "Vila Eva · Booking.com", stars: 5 },
  { quote: "Everything Was Perfect", text: "Everything was perfect. The apartment was very clean and had all the necessary amenities. The location is just a short walk from the lake, with bars and restaurants nearby. Communication was smooth throughout our stay.", name: "Artemis · Albania", source: "Dahlilas Home · Booking.com", stars: 5 },
  { quote: "Ideal Location by the Lake", text: "We truly enjoyed our stay. The apartment is only two minutes from the lake and very close to restaurants. Clean, comfortable, and perfectly positioned for exploring the area.", name: "Ina · Albania", source: "Dahlilas Home · Booking.com", stars: 5 },
];

function getVisible() {
  if (typeof window !== "undefined" && window.innerWidth < 768) return 1;
  if (typeof window !== "undefined" && window.innerWidth < 1024) return 2;
  return 3;
}

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(getVisible());

  // Update visible count on resize
  useState(() => {
    function handleResize() { setVisible(getVisible()); setCurrent(0); }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  const max = Math.max(0, reviews.length - visible);
  const cardWidth = 100 / visible;
  const gapOffset = visible === 1 ? 0 : visible === 2 ? 12 : 16;
  const shift = current * (cardWidth + gapOffset / visible);

  function prev() { setCurrent(c => Math.max(0, c - 1)); }
  function next() { setCurrent(c => Math.min(max, c + 1)); }

  return (
    <section className="tm-section">
      <div className="container">
        <div className="tm-header">
          <div className="eyebrow" style={{ justifyContent: "center" }}>
            <div className="eline"></div>
            <span className="etxt">Guest Stories</span>
            <div className="eline"></div>
          </div>
          <h2 className="tm-title">The Experience, <em>In Their Words</em></h2>
          <p className="tm-sub">Real guests, real stays, real Albania.</p>
        </div>
      </div>

      <div className="tm-slider-wrap">
        <div className="tm-track" style={{ transform: `translateX(-${shift}%)` }}>
          {reviews.map((r, i) => (
            <div className="tm-card" key={i}>
              <div className="tm-card-bar"></div>
              <div className="tm-stars">{"★".repeat(r.stars)}</div>
              <div className="tm-quote">"{r.quote}"</div>
              <p className="tm-text">{r.text}</p>
              <div className="tm-divider"></div>
              <div className="tm-name">{r.name}</div>
              <div className="tm-source">{r.source}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="tm-nav">
        <button className="tm-btn-nav" onClick={prev} disabled={current === 0}>&#8249;</button>
        <div className="tm-dots">
          {Array.from({ length: max + 1 }).map((_, i) => (
            <button key={i} className={i === current ? "tm-dot active" : "tm-dot"} onClick={() => setCurrent(i)} />
          ))}
        </div>
        <button className="tm-btn-nav" onClick={next} disabled={current >= max}>&#8250;</button>
      </div>
    </section>
  );
}